module.exports = "/_next/static/videos/womens-lacrosse-1-50d4244753f0d8f69e06563d0220ff02.webm";